var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "facebook"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.8333 1.25H12.8788C11.5728 1.25 10.3203 1.71094 9.39682 2.53141C8.47335 3.35188 7.95455 4.46468 7.95455 5.625V8.25H5V11.75H7.95455V18.75H11.8939V11.75H14.8485L15.8333 8.25H11.8939V5.625C11.8939 5.39294 11.9977 5.17038 12.1824 5.00628C12.3671 4.84219 12.6176 4.75 12.8788 4.75H15.8333V1.25Z",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.482acf3d015184112b677fe2cdeffa98.svg";
export { ForwardRef as ReactComponent };